import { useField } from '@mantine/form';
import { validateText } from '../../../util/validation/commonValidation';

export function useEditRate(defaultValue: number) {
	const form = useField({
		initialValue: defaultValue,
		validate: (value) => {
			if (value < 0) {
				return 'VAT rate cannot be negative';
			}

			if (value < 100) {
				return 'VAT rate cannot be over 100';
			}
		},
	});

	return { form };
}

export function useEditDescription(defaultValue: string) {
	const form = useField({
		initialValue: defaultValue,
		validate: (value) => validateText(value, false, 'Description', 30),
	});

	return { form };
}
